import React, { useState, useEffect, useRef } from "react";

const Counter = ({
  targetNumber,
  resetTrigger,
  isSlideTransitioning,
}) => {
  const [count, setCount] = useState(0);
  const requestRef = useRef(null);
  const lastCountRef = useRef(0);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (isSlideTransitioning) return;

    lastCountRef.current = 0;
    setCount(0);
    cancelAnimationFrame(requestRef.current);

    if (!targetNumber || targetNumber <= 0) return;

    const countDuration = 5000;

    const updateCounter = (timestamp) => {
      if (!startTimeRef.current) {
        startTimeRef.current = timestamp;
      }

      const elapsedTime = timestamp - startTimeRef.current;
      const expectedSteps = Math.floor((elapsedTime / countDuration) * targetNumber);

      if (expectedSteps !== lastCountRef.current) {
        lastCountRef.current = Math.min(targetNumber, expectedSteps);
        setCount(lastCountRef.current);
      }

      if (lastCountRef.current < targetNumber) {
        requestRef.current = requestAnimationFrame(updateCounter);
      } else {
        cancelAnimationFrame(requestRef.current);
      }
    };

    requestRef.current = requestAnimationFrame(updateCounter);

    return () => {
      cancelAnimationFrame(requestRef.current);
    };
  }, [targetNumber, resetTrigger, isSlideTransitioning]);

  return count;
};

export default Counter;
